import { FETCH_GET_ROUTES } from '../actions/GetRoutesAction';

const initialState = {
  routes: []
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_GET_ROUTES:
      return {
        ...action.payload
      }
    default:
      return {
        ...state
      }
  }
}


// WEBPACK FOOTER //
// ./src/reducers/RoutesReducer.js